import {gql} from 'apollo-boost';
import {STUDENT_NAME_FIELDS, TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_WEB_BOARD = gql`
  query getWebBoard($id: ID!){
    getWebBoard(id: $id) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_WEB_BOARDS = gql`
  query getWebBoards($id : ID!){
    getWebBoards (
      id: $id
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_WEB_BOARDS_BY_FILTER = gql`
  query getWebBoardsByFilter($webBoardFilterInput: WebBoardFilterInput){
    getWebBoardsByFilter (
      webBoardFilterInput: $webBoardFilterInput
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const ADD_WEB_BOARD = gql`
  mutation addWebBoard(
    $courseOutlineRegistrationId: ID!,
    $classSectionId: ID!,
    $academicPeriodId: ID!,
    $postBy: String!,
    $studentId: ID,
    $webBoardInput: WebBoardInput!
  ) {
    addWebBoard(
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      academicPeriodId: $academicPeriodId
      postBy: $postBy
      studentId: $studentId
      webBoardInput: $webBoardInput
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_WEB_BOARD = gql`
  mutation updateWebBoard(
    $id: ID!,
    $courseOutlineUnitId: ID!,
    $webBoardInput: WebBoardInput!
  ) {
    updateWebBoard(
      id: $id
      webBoardInput: $webBoardInput
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_REPLY_TO_WEB_BOARD = gql`
  mutation updateReplyToWebBoard(
    $id: ID!,
    $postBy: String!,
    $webBoardReplyInput: WebBoardReplyInput!
  ) {
    updateReplyToWebBoard(
      id: $id
      postBy: $postBy
      webBoardReplyInput: $webBoardReplyInput
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_WEB_BOARD_ALREADY_READ = gql`
  mutation updateWebBoardAlreadyRead(
    $id: ID!,
  ) {
    updateWebBoardAlreadyRead(
      id: $id
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_WEB_BOARD_HIT_RATE = gql`
  mutation updateWebBoardHitCount(
    $id: ID!,
  ) {
    updateWebBoardHitCount(
      id: $id
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const DELETE_WEB_BOARD = gql`
  mutation deleteWebBoard($id: ID!) {
    deleteWebBoard(
      id: $id
    ) {
      id sectionNo periodCode teacherCode studentCode
      topic topicDetail picturePath email
      ip hitRate replyQty hasNewReply updatedAt
      courseOutlineRegistration{ id }
      classSection{ id }
      academicPeriod{ id }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
        picturePath
      }
      webBoardReplies {
        id teacherCode studentCode
        replyMessage picturePath email
        ip updatedAt
        teacher {
          ...TeacherNameFields
          picturePath
        }
        student {
          ...StudentNameFields
          picturePath
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

